"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretRight = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CaretRight = () => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "#000000", viewBox: "0 0 256 256" }, { children: (0, jsx_runtime_1.jsx)("polyline", { points: "96 48 176 128 96 208", fill: "none", stroke: "#000000", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "16" }) })));
};
exports.CaretRight = CaretRight;
